import { PlusCircle, Trash } from "lucide-react";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";

/* eslint-disable @typescript-eslint/no-explicit-any */
const Precio = ({ setForm, form }: any) => {
  const days = ["LU", "MA", "MI", "JU", "VI", "SA", "DO"];

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, value: any) => {
    switch (e.target.name) {
      case "price":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "prices-guests":
        {
          let prices = form.PRICES;
          prices[value]["guests"] = e.target.value;
          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      case "prices-price":
        {
          let prices = form.PRICES;
          prices[value]["price"] = e.target.value;
          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: React.ChangeEvent<HTMLInputElement>, value: any) => {
    switch (e.target.name) {
      case "prices-day":
        {
          let prices = form.PRICES;
          let days = prices[value.index]["day"].split(",");

          if (days.indexOf(value.value) == -1) {
            days.push(value.value);
            days = days.filter((d: any) => d !== "");
            prices[value.index]["day"] = days.join(",");
          } else {
            delete days[days.indexOf(value.value)];
            days = days.filter((d: any) => d != null);
            days = days.filter((d: any) => d !== "");
            prices[value.index]["day"] = days.join(",");
          }

          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      case "remove":
        {
          const requestOptions = {
            method: "DELETE",
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/prices/${value.id}`, requestOptions)
            .then(async (response) => {
              console.log(response);

              let prices = form.PRICES;
              delete prices[value.index];
              prices = prices.filter((p: any) => p != null);

              setForm({
                ...form,
                PRICES: prices,
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "add":
        {
          const price = {
            day: "LU,MA,MI,JU,VI,SA,DO",
            name: "",
            description: "",
            guests: null,
            price: 0,
          };

          let prices = form.PRICES;
          prices.push(price);

          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="grid lg:grid-cols-1 gap-5 lg:gap-10 py-5 px-5">
      <div className="relative">
        <span className="font-bold text-primary mb-2 block">
          Ahora, fijá tu precio
        </span>
        <span className="block">Podés cambiarlo cuando quieras.</span>

        <input
          type="number"
          className="border-0 w-full text-6xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md w-full"
          value={form.price}
          name="price"
          onChange={(event) => onChange(event, null)}
        />


        <span className="block">
          Precio para huésped (Con impuestos): ${parseFloat(form.price) + (form.price / 100 * 20)}
        </span>
      </div>

      <div className="p-4">
        <label className="cursor-pointer flex">
          <PlusCircle className="text-black" />
          Agregar nuevo precio personalizado
          <button
            className="hidden"
            name="add"
            onClick={(e: any) => onClick(e, null)}
          ></button>
        </label>
      </div>

      {form.PRICES.map((price: any, index: number) => {
        return (
          <div className="mb-2 border p-4">
            <span className="font-bold text-primary mb-1 block">
              Precio personalizado
            </span>
            <span className="block">Podés cambiarlo cuando quieras.</span>
            <input
              type="number"
              className="border-0 w-full text-5xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
              value={price.price}
              name="prices-price"
              onChange={(event) => onChange(event, index)}
            />
            <div className="mb-3">
              <span className="block">
                Mostrar a partir de cuantos huespedes
              </span>
              <input
                type="text"
                className="w-full border
            text-3xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
                value={price.guests}
                name="prices-guests"
                onChange={(event) => onChange(event, index)}
              />
            </div>
            <div className=" mb-5">
              <span className="block mb-3">
                Mostrar solo algunos dias de la semana
              </span>
              <div className="lg:flex inline w-full">
                {days.map((day) => {
                  return (
                    <label
                      className={`flex  mb-1 cursor-pointer font-bold p-3 rounded-md me-1 ${price.day.includes(day)
                          ? "bg-primary text-white "
                          : "border hover:bg-primary hover:text-white"
                        }`}
                    >
                      {day}
                      <button
                        className="hidden"
                        name="prices-day"
                        onClick={(e: any) =>
                          onClick(e, { index: index, value: day })
                        }
                      ></button>
                    </label>
                  );
                })}
              </div>
            </div>
            <div className="">
              <label className="cursor-pointer flex border-0 rounded-xl p-2">
                <Trash />
                Quitar precio personalizado
                <button
                  className="hidden"
                  name="remove"
                  onClick={(e: any) => onClick(e, { id: price.id, index: index })}
                ></button>
              </label>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Precio;
